import {State} from '../types'

export const getComponentSettings = (state: State) => state.component.settings
